import { FormBuilder } from '@fareye/form-builder'
import { Modal, toast } from '@fareye/ui'
import React, { useEffect, useState } from 'react'
import { POI_CONFIG, POI_FORM_RENDERING, HEADER_INFLECTION } from '../../../config/constants'
import { isEmpty } from 'lodash'
import { cancelToken, put, post } from '@fareye/utils'

export default function PoiModal({ selectedPoi, setSelectedPoi }: any) {
  const [submitValue, setSubmitValues] = useState<any>({})
  const {poiConfig}=POI_CONFIG
  const source=cancelToken().source()
  const handleToggleModal = (toggle: boolean) => {
    setSelectedPoi((selectedPoi: any) => {
      return {
        ...selectedPoi,
        openModal: toggle
      }
    })
  }

  const handleUpdatePoiConfig= async(config: any,poiId:number) => {
    try {
        let url= `${poiConfig}/${poiId}`
        const {data}=await put(url,config,source.token, HEADER_INFLECTION)
        toast.success('Poi config updated successfully')
        handleToggleModal(false)
    } catch (error) {
        toast.error('Something went wrong')

    }
  }
  const handleAddPoiConfig= async(config: any) => {
    try {
        
        let url= `${poiConfig}`
        const {data}=await post(url,config,source.token, HEADER_INFLECTION)
        toast.success('Poi config added successfully')
        handleToggleModal(false)
    } catch (error) {
        toast.error('Something went wrong')
    }
}

  useEffect(() => {
    if (!isEmpty(submitValue)) {
        try {
          const {
            userId,
            identifier,
            value,
            radius,
            poiId,
            Type,
            poiType,
            lat,
            lng,
            latLngList,
            id
          } = submitValue.values
          let payload = {
            poiConfig:{
              userId,
              identifier: identifier.value,
              value,
              radius,
              poiId,
              poiType:poiType.value,
              lat,
              lng,
              _type:Type.value,
              latLngList
            }
          }
        if(selectedPoi.action==="edit"){
            handleUpdatePoiConfig(payload,id)
        }else{
            handleAddPoiConfig(payload)
        }
      } catch (error) {
        toast.error("Something went wrong...")
      }
    }
  }, [submitValue])

  return (
    <Modal
      toggleModal={selectedPoi.openModal}
      setToggleModal={handleToggleModal}
    >
      <FormBuilder
        config={POI_FORM_RENDERING as any}
        formDefaultValue={selectedPoi.data}
        setSubmitValues={setSubmitValues}
        baseUrl=""
      />
    </Modal>
  )
}
